module.exports = __webpack_public_path__ + "static/media/find-more.1c9a0e95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/find-more.svg
// module id = 1968
// module chunks = 0